export async function fetchZipCodeAddress(zipCode: string) {
  if (!zipCode || !zipCode.match(/^\d{5}-?\d{3}$/)) {
    return;
  }

  const cleanedZipCode = zipCode.replace(/\D/g, "");
  const response = await fetch(
    `https://viacep.com.br/ws/${cleanedZipCode}/json`,
  );
  const data = await response.json();

  return {
    address: data.logradouro,
    city: data.localidade,
    state: data.uf,
    zip_code: data.cep,
  };
}
